import script from "./ProductsAgreement.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductsAgreement.vue?vue&type=script&setup=true&lang=ts"

import "./ProductsAgreement.vue?vue&type=style&index=0&id=f7588188&lang=css&scoped=true"

import exportComponent from "/home/forge/client.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f7588188"]])

export default __exports__